import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { NewLineToHtml, SafeHTML } from '@common/pipes';
import { WindowDetectService } from '@service/window-detect.service';
import { FocusRemoverDirective } from '@helper/focus-remover.directive';

export class ConfirmData {
  public content = '';
  public template?: TemplateRef<any> | undefined;
  public title?: string = $localize`溫馨提醒`;
  public hideTitle?: boolean;
  public subTitle?: string;
  public singleBtnTitle?: string;
  public leftBtnTitle?: string;
  public rightBtnTitle?: string;
  public disableClose?: boolean;
  public warnText = false;

  constructor(init?: Partial<ConfirmData>) {
    Object.assign(this, init);
  }
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, SafeHTML, NewLineToHtml, FocusRemoverDirective],
})
export class ConfirmDialogComponent {
  readonly data: ConfirmData = inject(MAT_DIALOG_DATA);
  readonly windowService = inject(WindowDetectService);

  constructor(private dialogRef: MatDialogRef<ConfirmDialogComponent, boolean | undefined>) {}

  static open(
    dialog: MatDialog,
    data: ConfirmData,
    id?: string
  ): MatDialogRef<ConfirmDialogComponent, boolean | undefined> {
    return dialog.open(ConfirmDialogComponent, {
      disableClose: data.disableClose ?? true,
      data,
      id,
    });
  }

  onClick(isRight: boolean): void {
    this.dialogRef.close(isRight);
  }
}
